window.vehicleData = {
  models: [
    "Prado 150",
    "Prado 250",
    "Hilux N80",
    "Hilux N90",
    "Fortuner",
    "Landcruiser 76",
    "Landcruiser 78",
    "Landcruiser 79",
    "Landcruiser 79 (Facelift)",
    "Landcruiser 200",
    "Landcruiser 300",
    "Next Gen",
    "Everest",
    "Super Duty",
    "Tundra"
  ],

  years: {
    "Prado 150": [2017, 2018, 2019, 2020, 2021, 2022, 2023],
    "Prado 250": [2024, 2025, 2026],
    "Hilux N80": [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
    "Hilux N90": [2026],
    "Fortuner": [2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
    "Landcruiser 76": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
    "Landcruiser 78": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
    "Landcruiser 79": [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023],
    "Landcruiser 79 (Facelift)": [2024, 2025, 2026],
    "Landcruiser 200": [2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021],
    "Landcruiser 300": [2022, 2023, 2024, 2025, 2026],
    "Next Gen": [2022, 2023, 2024, 2025, 2026],
    "Everest": [2022, 2023, 2024, 2025, 2026],
    "Super Duty": [2026],
    "Tundra": [2025, 2026]
  },

  trims: {
    "Prado 150": ["GX", "GXL", "VX", "Kakadu", "Sahara"],
    "Prado 250": ["GX", "GXL", "VX", "Kakadu", "Altitude"],
    "Hilux N80": ["SR", "SR5", "Workmate", "Rogue"],
    "Hilux N90": ["SR", "SR5", "Workmate", "Rogue"],
    "Fortuner": ["GX", "GXL", "Crusade"],
    "Landcruiser 76": ["GXL", "Workmate"],
    "Landcruiser 78": ["GXL", "Workmate"],
    "Landcruiser 79": ["GX", "GXL", "Workmate"],
    "Landcruiser 79 (Facelift)": ["GX", "GXL", "Workmate"],
    "Landcruiser 200": ["GX", "GXL", "VX", "Sahara"],
    "Landcruiser 300": ["GX", "GXL", "VX", "Sahara", "GR"],
    "Next Gen": ["XL", "XLS", "XLT", "Sport", "Wildtrak", "Platinum"],
    "Super Duty": ["XL", "XLT"],
    "Everest": ["Ambiente", "Trend", "Sport", "Wildtrak", "Tremor", "Active", "Platinum"],
    "Tundra": ["Limited", "Platinum"]
  },

  cabType: {
    "Prado 150": ["Wagon"],
    "Prado 250": ["Wagon"],
    "Hilux N80": ["Dual Cab", "Single Cab", "Extra Cab"],
    "Hilux N90": ["Dual Cab", "Single Cab", "Extra Cab"],
    "Fortuner": ["Wagon"],
    "Landcruiser 76": ["Dual Cab", "Single Cab"],
    "Landcruiser 78": ["Wagon"],
    "Landcruiser 79": ["Dual Cab", "Single Cab"],
    "Landcruiser 79 (Facelift)": ["Dual Cab", "Single Cab"],
    "Landcruiser 200": ["Wagon"],
    "Landcruiser 300": ["Wagon"],
    "Next Gen": ["Dual Cab", "Single Cab", "Extra Cab"],
    "Everest": ["Wagon"],
    "Super Duty": ["Dual Cab", "Single Cab", "Extra Cab"],
    "Tundra": ["CrewMax"]
  },

  chassisType: {
    "Hilux N80": ["Tub Chassis", "Cab Chassis"],
    "Hilux N90": ["Tub Chassis", "Cab Chassis"]
  },

  colours: [
    "Black",
    "Aztec (Hammertone)"
  ],

  barTypes: {
    "Prado 150": ['2.5"', '3"'],
    "Prado 250": ['3"'],
    "Hilux N80": ['2.5"', '3"'],
    "Hilux N90": ['2.5"', '3"'],
    "Fortuner": ['2.5"', '3"'],
    "Landcruiser 76": ['3"'],
    "Landcruiser 78": ['3"'],
    "Landcruiser 79": ['3"'],
    "Landcruiser 79 (Facelift)": ['3"'],
    "Landcruiser 200": ['3"'],
    "Landcruiser 300": ['3"'],
    "Next Gen": ['3"'],
    "Everest": ['3"'],
    "Super Duty": ['3"'],
    "Tundra": ['3"']
  },

  sideRailsOptions: {
    "Prado 150": ["Dual", "Single", "None"],
    "Prado 250": ["Dual", "Single", "None"],
    "Hilux N80": ["Dual", "Single", "None"],
    "Hilux N90": ["Dual", "Single", "None"],
    "Fortuner": ["Dual", "Single", "None"],
    "Landcruiser 76": ["Dual", "None"],
    "Landcruiser 78": ["Dual", "None"],
    "Landcruiser 79": ["Dual", "None"],
    "Landcruiser 79 (Facelift)": ["Dual", "None"],
    "Landcruiser 200": ["Dual", "None"],
    "Landcruiser 300": ["Dual", "Single", "None"],
    "Next Gen": ["Dual", "None"],
    "Everest": ["Dual", "None"],
    "Super Duty": ["Dual", "None"],
    "Tundra": ["Dual", "None"]
  },

  barPrices: [
    { make: "Toyota", vehicle: "Prado 150", bar_type: '2.5"', winch_compatible: "Yes", price: 4600, item_code: 10 },
    { make: "Toyota", vehicle: "Prado 150", bar_type: '2.5"', winch_compatible: "No", price: 4300, item_code: 25 },
    { make: "Toyota", vehicle: "Prado 150", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 9 },
    { make: "Toyota", vehicle: "Prado 150", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 90 },

    { make: "Toyota", vehicle: "Prado 250", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 31 },
    { make: "Toyota", vehicle: "Prado 250", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 29 },

    { make: "Toyota", vehicle: "Hilux N80", bar_type: '2.5"', winch_compatible: "Yes", price: 4600, item_code: 4 },
    { make: "Toyota", vehicle: "Hilux N80", bar_type: '2.5"', winch_compatible: "No", price: 4300, item_code: 3 },
    { make: "Toyota", vehicle: "Hilux N80", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 21 },
    { make: "Toyota", vehicle: "Hilux N80", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 20 },

    { make: "Toyota", vehicle: "Hilux N90", bar_type: '2.5"', winch_compatible: "Yes", price: 4600, item_code: 98 },
    { make: "Toyota", vehicle: "Hilux N90", bar_type: '2.5"', winch_compatible: "No", price: 4300, item_code: 97 },
    { make: "Toyota", vehicle: "Hilux N90", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 96 },
    { make: "Toyota", vehicle: "Hilux N90", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 95 },

    { make: "Toyota", vehicle: "Fortuner", bar_type: '2.5"', winch_compatible: "Yes", price: 4600, item_code: 27 },
    { make: "Toyota", vehicle: "Fortuner", bar_type: '2.5"', winch_compatible: "No", price: 4300, item_code: 28 },
    { make: "Toyota", vehicle: "Fortuner", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 40 },
    { make: "Toyota", vehicle: "Fortuner", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 35 },

    { make: "Toyota", vehicle: "Landcruiser 76", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 15 },
    { make: "Toyota", vehicle: "Landcruiser 76", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 16 },

    { make: "Toyota", vehicle: "Landcruiser 78", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 15 },
    { make: "Toyota", vehicle: "Landcruiser 78", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 16 },

    { make: "Toyota", vehicle: "Landcruiser 79", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 15 },
    { make: "Toyota", vehicle: "Landcruiser 79", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 16 },

    { make: "Toyota", vehicle: "Landcruiser 79 (Facelift)", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 2 },
    { make: "Toyota", vehicle: "Landcruiser 79 (Facelift)", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 1 },

    { make: "Toyota", vehicle: "Landcruiser 200", bar_type: '3"', winch_compatible: "Yes", price: 5300, item_code: 6 },
    { make: "Toyota", vehicle: "Landcruiser 200", bar_type: '3"', winch_compatible: "No", price: 5000, item_code: 5 },

    { make: "Toyota", vehicle: "Landcruiser 300", bar_type: '3"', winch_compatible: "Yes", price: 4900, item_code: 8 },
    { make: "Toyota", vehicle: "Landcruiser 300", bar_type: '3"', winch_compatible: "No", price: 4600, item_code: 7 },

    { make: "Ford", vehicle: "Next Gen", bar_type: '3"', winch_compatible: "Yes", price: 5400, item_code: 64 },
    { make: "Ford", vehicle: "Next Gen", bar_type: '3"', winch_compatible: "No", price: 5200, item_code: 45 },

    { make: "Ford", vehicle: "Everest", bar_type: '3"', winch_compatible: "Yes", price: 5400, item_code: 93 },
    { make: "Ford", vehicle: "Everest", bar_type: '3"', winch_compatible: "No", price: 5200, item_code: 92 },

    { make: "Ford", vehicle: "Super Duty", bar_type: '3"', winch_compatible: "Yes", price: 5400, item_code: 80 },
    { make: "Ford", vehicle: "Super Duty", bar_type: '3"', winch_compatible: "No", price: 5100, item_code: 82 },

    { make: "Toyota", vehicle: "Tundra", bar_type: '3"', winch_compatible: "No", price: 5600, item_code: 111 }
  ],

  sideRailsPrices: [
    { vehicle: "Prado 150", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Prado 150", side_rails: "Single", price: 1900, item_code: 11 },
    { vehicle: "Prado 150", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Prado 250", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Prado 250", side_rails: "Single", price: 1900, item_code: 11 },
    { vehicle: "Prado 250", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Hilux N80", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Hilux N80", side_rails: "Single", price: 1900, item_code: 11 },
    { vehicle: "Hilux N80", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Hilux N90", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Hilux N90", side_rails: "Single", price: 1900, item_code: 11 },
    { vehicle: "Hilux N90", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Fortuner", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Fortuner", side_rails: "Single", price: 1900, item_code: 11 },
    { vehicle: "Fortuner", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 76", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Landcruiser 76", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 78", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Landcruiser 78", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 79", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Landcruiser 79", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 79 (Facelift)", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Landcruiser 79 (Facelift)", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 200", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Landcruiser 200", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 300", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Landcruiser 300", side_rails: "Single", price: 1900, item_code: 11 },
    { vehicle: "Landcruiser 300", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Next Gen", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Next Gen", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Everest", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Everest", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Super Duty", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Super Duty", side_rails: "None", price: 0, item_code: null },

    { vehicle: "Tundra", side_rails: "Dual", price: 2300, item_code: 12 },
    { vehicle: "Tundra", side_rails: "None", price: 0, item_code: null }
  ],

  bashPlates: [
    { vehicle: "Hilux N80", cab_type: "N/A", bash_plate: "BSF Hilux 2 Piece Underbody Protection – Bash Set", price: 590.00, item_code: 101 },
    { vehicle: "Hilux N80", cab_type: "N/A", bash_plate: "BSF Hilux 3 Piece Underbody Protection – Bash Set", price: 680.90, item_code: 104 },
    { vehicle: "Hilux N80", cab_type: "N/A", bash_plate: "None", price: 0, item_code: null },

    { vehicle: "Hilux N90", cab_type: "N/A", bash_plate: "BSF Hilux N90 2 Piece Bash Plate", price: 600.00, item_code: 106 },
    { vehicle: "Hilux N90", cab_type: "N/A", bash_plate: "BSF Hilux N90 3 Piece Bash Plate", price: 750.00, item_code: 105 },
    { vehicle: "Hilux N90", cab_type: "N/A", bash_plate: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 300", cab_type: "N/A", bash_plate: "BSF LandCruiser 300 Bash Plate", price: 750.00, item_code: 107 },
    { vehicle: "Landcruiser 300", cab_type: "N/A", bash_plate: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 79", cab_type: "Dual Cab", bash_plate: "BSF LC 79 Dual Cab: Bash Plate", price: 270.00, item_code: 103 },
    { vehicle: "Landcruiser 79", cab_type: "Single Cab", bash_plate: "BSF LC 79 Single Cab: Bash Plate", price: 270.00, item_code: 102 },
    { vehicle: "Landcruiser 79", cab_type: "Dual Cab", bash_plate: "None", price: 0, item_code: null },
    { vehicle: "Landcruiser 79", cab_type: "Single Cab", bash_plate: "None", price: 0, item_code: null },

    { vehicle: "Landcruiser 79 (Facelift)", cab_type: "Dual Cab", bash_plate: "BSF LC 79 Dual Cab: Bash Plate", price: 270.00, item_code: 103 },
    { vehicle: "Landcruiser 79 (Facelift)", cab_type: "Single Cab", bash_plate: "BSF LC 79 Single Cab: Bash Plate", price: 270.00, item_code: 102 },
    { vehicle: "Landcruiser 79 (Facelift)", cab_type: "Dual Cab", bash_plate: "None", price: 0, item_code: null },
    { vehicle: "Landcruiser 79 (Facelift)", cab_type: "Single Cab", bash_plate: "None", price: 0, item_code: null }
  ],

  winches: [
    { winch: "None", price: 0, item_code: null },
    { winch: "Runva 11/13XP Winch", price: 1250, item_code: 13 },
    { winch: "Runva Winch 11XS (Synthetic rope - compact 15M cable)", price: 950, item_code: 65 }
  ],

  lights: [
    { lights: "None", price: 0, item_code: null },
    { lights: 'NARVA - 12/24V 9" EX2 DRIVING LIGHT KIT (PAIR)', price: 630, item_code: 43 },
    { lights: "LP9 Baja Design Driving Lights", price: 1996.36, item_code: 34 },
    { lights: 'Ultra Vision - RAPTOR LED DRIVING LIGHTS 9" (PAIR)', price: 753.636, item_code: 57 },
    { lights: 'NITRO 180 Maxx 9" LED Driving Light (Pair)', price: 1461.2, item_code: 63 }
  ],

  fittingLocations: [
    { fitting_location: "Goondiwindi", price: 0, item_code: 202 },

    { fitting_location: "Dubbo", price: 700, item_code: 201 },

    {
      fitting_location: "Emerald Tint - Emerald QLD (Certified Fitter)",
      price: 1937,
      item_code: 2000,
      freight_item_code: 2001
    },

    {
      fitting_location: "Mallee 4x4 - Mildura (Certified Fitter)",
      price: 1754.55,
      item_code: 2003,
      freight_item_code: 2002
    },

    {
      fitting_location: "Alice Springs",
      price: 1000,
      item_code: 303,
      freight_item_code: 302
    },

    { fitting_location: "None", price: 350, item_code: 200 }
  ],

  relocationRules: [

    // Hilux N80 (2021–2025)
    { vehicle: "Hilux N80", year_from: 2021, year_to: 2025, trim: "SR5", chassis_type: "Cab Chassis", camera_relocation_price: 0, sensor_relocation_price: 0, camera_item_code: null, sensor_item_code: null },
    { vehicle: "Hilux N80", year_from: 2021, year_to: 2025, trim: "SR5", chassis_type: "Tub Chassis", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },

    { vehicle: "Hilux N80", year_from: 2021, year_to: 2025, trim: "SR", chassis_type: "Tub Chassis", camera_relocation_price: 0, sensor_relocation_price: 200, camera_item_code: null, sensor_item_code: 14 },
    { vehicle: "Hilux N80", year_from: 2021, year_to: 2025, trim: "SR", chassis_type: "Cab Chassis", camera_relocation_price: 0, sensor_relocation_price: 0, camera_item_code: null, sensor_item_code: null },


    // Hilux N90 (2026)

    // SR
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2029, trim: "SR", chassis_type: "Cab Chassis", camera_relocation_price: 150, sensor_relocation_price: 0, camera_item_code: 22, sensor_item_code: null },
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2029, trim: "SR", chassis_type: "Tub Chassis", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },

    // SR5
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2029, trim: "SR5", chassis_type: "Cab Chassis", camera_relocation_price: 150, sensor_relocation_price: 0, camera_item_code: 22, sensor_item_code: null },
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2026, trim: "SR5", chassis_type: "Tub Chassis", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },

    // Workmate
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2029, trim: "Workmate", chassis_type: "Cab Chassis", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2029, trim: "Workmate", chassis_type: "Tub Chassis", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },

    // Rogue
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2029, trim: "Rogue", chassis_type: "Cab Chassis", camera_relocation_price: 150, sensor_relocation_price: 0, camera_item_code: 22, sensor_item_code: null },
    { vehicle: "Hilux N90", year_from: 2026, year_to: 2029, trim: "Rogue", chassis_type: "Tub Chassis", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Fortuner (2020–2026)
    { vehicle: "Fortuner", year_from: 2020, year_to: 2026, trim: "GX", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Fortuner", year_from: 2020, year_to: 2026, trim: "GXL", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Fortuner", year_from: 2020, year_to: 2026, trim: "Crusade", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Prado 150
    { vehicle: "Prado 150", year_from: 2019, year_to: 2023, trim: "VX", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Prado 150", year_from: 2019, year_to: 2023, trim: "Sahara", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Prado 250
    { vehicle: "Prado 250", year_from: 2024, year_to: 2026, trim: "GX", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Prado 250", year_from: 2024, year_to: 2029, trim: "GXL", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Prado 250", year_from: 2024, year_to: 2029, trim: "VX", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Prado 250", year_from: 2024, year_to: 2029, trim: "Kakadu", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Prado 250", year_from: 2024, year_to: 2029, trim: "Altitude", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Landcruiser 200
    { vehicle: "Landcruiser 200", year_from: 2019, year_to: 2021, trim: "GXL", chassis_type: "N/A", camera_relocation_price: 0, sensor_relocation_price: 200, camera_item_code: null, sensor_item_code: 14 },
    { vehicle: "Landcruiser 200", year_from: 2019, year_to: 2021, trim: "VX", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Landcruiser 200", year_from: 2019, year_to: 2021, trim: "Sahara", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Landcruiser 300
    { vehicle: "Landcruiser 300", year_from: 2022, year_to: 2029, trim: "GXL", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Landcruiser 300", year_from: 2022, year_to: 2029, trim: "VX", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Landcruiser 300", year_from: 2022, year_to: 2029, trim: "Sahara", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Landcruiser 300", year_from: 2022, year_to: 2029, trim: "GR", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Next Gen Ranger
    { vehicle: "Next Gen", year_from: 2022, year_to: 2029, trim: "XL", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Next Gen", year_from: 2022, year_to: 2029, trim: "XLS", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Next Gen", year_from: 2022, year_to: 2029, trim: "XLT", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Next Gen", year_from: 2022, year_to: 2029, trim: "Sport", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Next Gen", year_from: 2022, year_to: 2029, trim: "Wildtrak", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Next Gen", year_from: 2022, year_to: 2029, trim: "Platinum", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Super Duty
    { vehicle: "Super Duty", year_from: 2026, year_to: 2029, trim: "XL", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Super Duty", year_from: 2026, year_to: 2029, trim: "XLT", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },


    // Tundra (2025-2026)
    { vehicle: "Tundra", year_from: 2025, year_to: 2026, trim: "Limited", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Tundra", year_from: 2025, year_to: 2026, trim: "Platinum", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },

    // Everest
    { vehicle: "Everest", year_from: 2022, year_to: 2029, trim: "Ambiente", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Everest", year_from: 2022, year_to: 2029, trim: "Trend", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Everest", year_from: 2022, year_to: 2029, trim: "Sport", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Everest", year_from: 2022, year_to: 2029, trim: "Wildtrak", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Everest", year_from: 2022, year_to: 2029, trim: "Tremor", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Everest", year_from: 2022, year_to: 2029, trim: "Active", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 },
    { vehicle: "Everest", year_from: 2022, year_to: 2029, trim: "Platinum", chassis_type: "N/A", camera_relocation_price: 150, sensor_relocation_price: 200, camera_item_code: 22, sensor_item_code: 14 }
  ]
};